export default __webpack_public_path__ + "static/media/health_coach.125e6a8b.png";